import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment.local';
import {NotificationUserResponse} from "../../models/notifications-users/NotificationUserResponse";
import {NotificationUserBody} from "../../models/notifications-users/NotificationUserBody";

@Injectable({
  providedIn: 'root'
})
export class NotificationsUsersService {

  private apiUrl = `${environment.apiUrl}/notifications-users`;

  constructor(private http: HttpClient) {
  }

  getNotifications(p: { user_id: number }): Observable<NotificationUserResponse> {
    return this.http.get<NotificationUserResponse>(this.apiUrl, {params: p});
  }

  getNotificationById(id: number): Observable<NotificationUserResponse> {
    return this.http.get<NotificationUserResponse>(`${this.apiUrl}/${id}`);
  }

  updateNotification(id: number, notificationBody: NotificationUserBody): Observable<NotificationUserResponse> {
    return this.http.put<NotificationUserResponse>(`${this.apiUrl}/${id}`, notificationBody);
  }

  deleteNotification(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
